import React, {useEffect, useRef } from 'react';
import { motion, AnimatePresence } from "framer-motion"
import styled from 'styled-components';


const Dialog = styled.div`
    display: flex; 
    align-items: center; 
    justify-content: center; 
    position: fixed;
    top: 0;
    left: 0;
    z-index: 100;
    width: 100%;
    height: 100%;
    padding: 0 var(--sp-16);
    background-color: rgba(0,0,0,0.7);
    & .in-layout{
        display: flex; 
        align-items: center; 
        justify-content: center; 
        width: 100%;
        max-width: 32rem;
        height: auto;
        border-radius: var(--radius-20);
        background-color: var(--color-white);
        outline: none; /* 포커스 표시 제거 */
        
    }
`;

 const Modal = ({ isOpen, setIsOpen, children}) => {
    const layoutRef = useRef(null);

    useEffect(() => {
        if (isOpen) {
        // 약간의 지연을 주어 렌더 완료 후 포커스 이동
        const timer = setTimeout(() => {
            layoutRef.current?.focus();
        }, 100);
        return () => clearTimeout(timer);
        }
    }, [isOpen]);

	return (
		<AnimatePresence>
			{isOpen && (
				<Dialog
					open={isOpen}
					onClose={setIsOpen}
                    role="dialog"
                    aria-modal="true"
				>
                    
                    <motion.div
                        ref={layoutRef}
                        className="in-layout"
                        tabIndex={-1} // 포커스 가능하게 설정
                        onClick={(e) => e.stopPropagation()} // 배경 클릭 시 닫히지 않도록 방지
                        initial={{
                            opacity: 0,
                            scale: 0.75,
                        }}
                        animate={{
                            opacity: 1,
                            scale: 1,
                            transition: {
                                ease: "easeOut",
                                duration: 0.15,
                            },
                        }}
                        exit={{
                            opacity: 0,
                            scale: 0.75,
                            transition: {
                                ease: "easeIn",
                                duration: 0.15,
                            },
                        }}
                    >

                        {children}
                         
                    </motion.div>
					
				</Dialog>
			)}
		</AnimatePresence>
	)
}

export default Modal;